// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"291":"3b970105","672":"cae1581c"}[chunkId] + ".chunk.js";
};